import { useState } from 'react';
import TickerRow from './TickerRow';
import { LIVE_CADENCE_LABEL } from '../lib/copy-contract';
import './live-panel.css';

function LivePanel({ data, mapSlot, scopeLabel = 'NYC METRO', compact = false, highlightId: extHighlightId, onHighlight: extOnHighlight }) {
  const [localHighlight, setLocalHighlight] = useState(null);
  const highlightId = extHighlightId !== undefined ? extHighlightId : localHighlight;
  const setHighlightId = extOnHighlight || setLocalHighlight;
  const { hoveringCount, airborneCount, ticker, source, refreshedSecondsAgo, locationSet } = data;
  const quiet = hoveringCount === 0 && airborneCount === 0;
  const where = locationSet ? 'in your area' : 'in NYC metro';

  let headlineN;
  let unit;
  if (quiet) {
    headlineN = '0';
    unit = 'Quiet right now — see who hovered recently below.';
  } else if (hoveringCount > 0) {
    headlineN = String(hoveringCount);
    unit = `helicopters hovering right now · ${airborneCount} airborne ${where}`;
  } else {
    headlineN = String(airborneCount);
    unit = `${airborneCount === 1 ? 'helicopter' : 'helicopters'} airborne ${where} · none classified as hovering yet`;
  }

  if (compact) {
    return (
      <div className="live-panel-compact">
        <span className="live-pulse-dot" aria-hidden />
        <span>{hoveringCount} OVERHEAD · {scopeLabel.toUpperCase()}</span>
      </div>
    );
  }

  return (
    <section className="live-panel" aria-label="live activity">
      <div className="live-pulse">
        <span className="dot" aria-hidden /> LIVE · {scopeLabel.toUpperCase()}
        {locationSet ? ' · YOUR LOCATION SET' : ''}
        <span className="live-cadence"> · {LIVE_CADENCE_LABEL}</span>
      </div>
      <div className="live-lead">
        <div className="live-bignum">{headlineN}</div>
        <div className="live-unit">{unit}</div>
      </div>
      <div className="live-pair">
        <div className="live-map-slot">{mapSlot}</div>
        <div className="live-ticker">
          <div className="live-ticker-header">
            <span>{'// LIVE FEED'}</span>
            <span>{ticker.length} ACTIVE · {LIVE_CADENCE_LABEL}</span>
          </div>
          {ticker.length === 0 ? (
            <div className="live-ticker-empty">No live activity. {refreshedSecondsAgo != null ? `Refreshed ${refreshedSecondsAgo}s ago.` : ''}</div>
          ) : (
            ticker.map((rw) => (
              <TickerRow
                key={rw.icao24 + ':' + rw.timeLabel}
                row={rw}
                onHighlight={setHighlightId}
                isHighlighted={rw.icao24 === highlightId}
              />
            ))
          )}
        </div>
      </div>
      <div className="live-source">
        Source: {source}
        {refreshedSecondsAgo != null && ` · refreshed ${refreshedSecondsAgo}s ago`}
      </div>
    </section>
  );
}

export default LivePanel;
